import { GetCalendarIntegrationsSummariesQuery, GetCalendarIntegrationsSummariesResponse } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'
import { FilterValue, applySearchParams, urlToPathnameAndSearch } from '../utils'

const pathname = `/api/${apiVersion}/calendar-integrations-summaries`

const makeGetCalendarIntegrationsSummaries =
  (baseUrl: string, config: HttpClientConfig) =>
  async (query: GetCalendarIntegrationsSummariesQuery): Promise<GetCalendarIntegrationsSummariesResponse> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, query as unknown as Record<string, FilterValue>)

    const pathnameAndSearch = urlToPathnameAndSearch(url)

    const response = await service(baseUrl).get<GetCalendarIntegrationsSummariesResponse>(pathnameAndSearch, config)

    return response.data
  }

export { makeGetCalendarIntegrationsSummaries }
